import Vue from 'vue';
import VueFire from 'vuefire';
import AsyncComputed from 'vue-async-computed';
import App from './App.vue';
import router from './router';
import VueFirebaseCRUD from './plugins/VueFirebaseCRUD';
import VueGoogleMapsLoader from './plugins/VueGoogleMaps';
import VueFirestoreAutoRebind from './plugins/VueFirestoreAutoRebind';
import VueI18n from './plugins/VueI18n';

Vue.config.productionTip = false;

Vue.use(VueFirebaseCRUD);
Vue.use(VueFire);
Vue.use(VueFirestoreAutoRebind);
Vue.use(VueGoogleMapsLoader);
Vue.use(AsyncComputed);
Vue.use(VueI18n);

new Vue({
  router,
  render: h => h(App),
}).$mount('#js--gftb-void');
